const MonthName = [
    {
        no: 1,
        name: "มกราคม"
    },
    {
        no: 2,
        name: "กุมภาพันธ์"
    },
    {
        no: 3,
        name: "มีนาคม"
    },
    {
        no: 4,
        name: "เมษายน"
    },
    {
        no: 5,
        name: "พฤษภาคม"
    },
    {
        no: 6,
        name: "มิถุนายน"
    },
    {
        no: 7,
        name: "กรกฎาคม"
    },
    {
        no: 8,
        name: "สิงหาคม"
    },
    {
        no: 9,
        name: "กันยายน"
    },
    {
        no: 10,
        name: "ตุลาคม"
    },
    {
        no: 11,
        name: "พฤศจิกายน"
    },
    {
        no: 12,
        name: "ธันวาคม"
    }
]

export default MonthName;